var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.65784 3.17857C5.14829 3.35425 3.16699 5.44573 3.16699 7.99996C3.16699 10.6693 5.33095 12.8333 8.00033 12.8333C10.1389 12.8333 11.9535 11.4441 12.5902 9.51907C12.1001 9.72153 11.5631 9.83329 11.0003 9.83329C8.69914 9.83329 6.83366 7.96781 6.83366 5.66663C6.83366 4.73386 7.1404 3.87269 7.65784 3.17857ZM2.16699 7.99996C2.16699 4.7783 4.77866 2.16663 8.00033 2.16663C8.30007 2.16663 8.59484 2.18928 8.88296 2.23304C9.08227 2.26331 9.2439 2.41032 9.29289 2.60587C9.34188 2.80142 9.26863 3.00726 9.10714 3.12792C8.33315 3.70619 7.83366 4.62801 7.83366 5.66663C7.83366 7.41553 9.25142 8.83329 11.0003 8.83329C11.7565 8.83329 12.4495 8.56889 12.994 8.12705C13.1505 8.00009 13.3679 7.97945 13.5454 8.07469C13.723 8.16994 13.826 8.36245 13.8068 8.56303C13.5232 11.5208 11.0321 13.8333 8.00033 13.8333C4.77866 13.8333 2.16699 11.2216 2.16699 7.99996Z",
    fill: "#282526"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.28c1a12800c8ea2a71e22fb83a9ba34a.svg";
export { ForwardRef as ReactComponent };